<div>

    <div class="dienstleistungsmodule-toolbar">
        <mat-form-field redispatchProvideReadonly>
            <mat-label>Filter</mat-label>
            <input matInput data-qa="filter" (keyup)="applyFilter($event)" #input>
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
        </mat-form-field>
    </div>

    <table [dataSource]="dienstleistungsmoduleList"
           mat-table
           class="dienstleistungsmodule-table"
           data-qa="data-table">

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let module; columns: columnsToDisplay"
            (click)="openDienstleistungsModule(module)"></tr>

        <ng-container matColumnDef="dienstleistungsmodule">
            <th mat-header-cell *matHeaderCellDef>Interne programmatisch Bezeichnung</th>
            <td mat-cell *matCellDef="let module;">{{module.dienstleistungsmodule}}</td>
        </ng-container>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let module;">{{module.title}}</td>
        </ng-container>

    </table>
</div>
